import type { ZodSimplify } from '@mntn-dev/utility-types'
import { EnumBuilder } from '@mntn-dev/utility-types'

export const [ChargeStates, ChargeStatusSchema] = EnumBuilder(
  'pending',
  'approved',
  'due',
  'overdue',
  'paid',
  'voided',
  'refunded'
)

export type ChargeStatus = ZodSimplify<typeof ChargeStatusSchema>
